import React from 'react';
import { Modal, TouchableWithoutFeedback, useWindowDimensions } from "react-native";
import { View } from '../../../src/Components/Themed';
import { FlashHolder } from 'be-components';
import type { CompanyProps, LocationProps, MyPlayerProps, PlayerBalanceProps } from '../../../src/types';
import MarketHeader from '../../market2/components/MarketHeader';

type GlobalFlashModalProps = {
    mode:'desktop'|'mobile',
    visible: boolean,
    me?:MyPlayerProps,
    restricted_flash_ids?:string[],
    my_balance?:PlayerBalanceProps,
    poll_id?:string,
    default_poll_id?:string,
    location?:LocationProps,
    company:CompanyProps,
    insets: { top:number, bottom:number, left:number, right:number },
    onClose:() => void,
    onShowProfile:() => void,
    onShowWallet: () => void,
    onRequestAuthenticate:() => void,
    onRequestLocation:() => void
}
const GlobalFlashModal = ({ visible, company, location, restricted_flash_ids, default_poll_id, me, my_balance, mode, poll_id, insets, onShowProfile, onShowWallet, onClose, onRequestAuthenticate, onRequestLocation }:GlobalFlashModalProps) => {
    const { height } = useWindowDimensions();

    return (
        <Modal
            style={{ flex:1 }}
            transparent
            animationType={mode=='desktop' ? 'fade' : 'slide'}
            visible={visible}
        >
            <TouchableWithoutFeedback style={{ flex:1 }} onPress={() => onClose()}>
            <View type='blur' style={mode=='desktop' ? { flex:1, justifyContent:'center', alignItems:'center' }:{ flex:1, justifyContent:'flex-end', padding:10 }}>
                <View transparent style={mode=='desktop'? { borderRadius:22, width:500 }:{ paddingBottom:insets.bottom }}>
                    <TouchableWithoutFeedback>
                    <View float>
                        <MarketHeader 
                            me={me}
                            onClose={() => onClose()}
                            header_style={{ borderTopRightRadius:8, borderTopLeftRadius:8 }}
                            my_balance={my_balance}
                            mode={mode}
                            company={company}
                            onShowProfile={() => {
                                onClose()
                                onShowProfile()
                            }}
                            onShowWallet={() => {
                                onClose()
                                onShowWallet()
                            }}
                            onRequestAuthenticate={() => onRequestAuthenticate()}
                        />
                        <View style={{ maxHeight:height - insets.top - insets.bottom - 45 }}>
                            {visible ?
                            <FlashHolder
                                company_id={company.company_id}
                                player={me}
                                location={location}
                                restricted_flash_ids={restricted_flash_ids}
                                default_poll_id={default_poll_id}
                                init_expanded={true}
                                poll_id={poll_id}
                                player_id={me?.player_id}
                                onRequestAuthenticate={onRequestAuthenticate}
                                onRequestLocation={onRequestLocation}
                            />
                            :<></>}
                        </View>
                    </View>
                    </TouchableWithoutFeedback>
                </View>
            </View>
            </TouchableWithoutFeedback>
        </Modal>
    )
}

export default GlobalFlashModal